import "rxjs/add/operator/map";
import "rxjs/add/operator/switchMap";
import { Injectable } from "@angular/core";
import { Actions, Effect } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable } from "rxjs/Observable";
import { SettingsService } from "./settings.service";
import * as SettingsActions from "../user/user.actions";
import {
  SaveSettingsAction,
  SaveSettingsSuccessAction,
} from "../user/user.actions";
import { NotificationsService } from "angular2-notifications";
import { S3Service } from "../../services/s3.service";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators/map";
import { catchError } from "rxjs/operators/catchError";
import { Settings } from "./settings.model";

@Injectable()
export class SettingsEffects {
  constructor(
    private actions$: Actions,
    private settingsService: SettingsService,
    private notificationService: NotificationsService,
    private s3Service: S3Service,
    private translate: TranslateService,
  ) {}

  @Effect()
  save: Observable<Action> = this.actions$
    .ofType(SettingsActions.ActionTypes.SAVE_SETTINGS)
    .map((action: SaveSettingsAction) => action.payload)
    .switchMap((settings) => {
      if (settings.logoFile) {
        return this.s3Service
          .putFileToS3("logos", settings.logoFile)
          .map((url) => {
            settings.logo = url;
            delete settings.logoFile;
            return settings;
          });
      } else {
        settings.logo = null;
        return Observable.of(settings);
      }
    })
    .switchMap((settings: Settings) => {
      return this.settingsService.updateSettings(settings).pipe(
        map(
          (_settings) =>
            new SettingsActions.SaveSettingsSuccessAction(_settings),
        ),
        catchError(() =>
          Observable.of(new SettingsActions.SaveSettingsFailAction()),
        ),
      );
    })
    .catch(() => {
      this.notificationService.error("Problem occurred uploading logo");
      return Observable.of(null);
    });

  @Effect()
  save_success: Observable<Action> = this.actions$
    .ofType(SettingsActions.ActionTypes.SAVE_SETTINGS_SUCCESS)
    .map((action: SaveSettingsSuccessAction) => action.payload)
    .switchMap((settings) => {
      // change language
      const currentLanguage = this.translate.currentLang;
      const lang = settings.language.substring(0, 2);

      localStorage.setItem("lang", lang);

      this.translate.use(lang);

      if (currentLanguage !== lang) {
        // we need to reload language
        location.reload();
      }

      return Observable.of(
        this.notificationService.success(
          this.translate.instant("settings.notifications.save_success.title"),
          this.translate.instant("settings.notifications.save_success.text"),
        ),
      );
    });

  @Effect()
  save_fail: Observable<Action> = this.actions$
    .ofType(SettingsActions.ActionTypes.SAVE_SETTINGS_FAIL)
    .switchMap(() => {
      return Observable.of(
        this.notificationService.error(
          this.translate.instant("settings.notifications.save_fail.title"),
          this.translate.instant("settings.notifications.save_fail.text"),
        ),
      );
    });
}



// WEBPACK FOOTER //
// /app/src/app/core/store/settings/settings.effects.ts